<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_702_5000)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#D80027"
      />
      <path
        d="M6.56719 7.30469L7.60312 10.4922H10.9547L8.24531 12.4656L9.28125 15.6531L6.56719 13.6844L3.85313 15.6531L4.89375 12.4656L2.17969 10.4922H5.53125L6.56719 7.30469Z"
        fill="#FFDA44"
      />
      <path
        d="M14.227 18.5867L13.4348 17.6117L12.2629 18.0664L12.9426 17.0117L12.1504 16.032L13.3645 16.3555L14.0488 15.3008L14.1145 16.557L15.3332 16.8805L14.1566 17.3305L14.227 18.5867Z"
        fill="#FFDA44"
      />
      <path
        d="M15.802 15.7273L16.177 14.5273L15.1504 13.8008L16.4066 13.782L16.777 12.582L17.1848 13.7727L18.441 13.7586L17.4332 14.5086L17.8363 15.6992L16.8098 14.9727L15.802 15.7273Z"
        fill="#FFDA44"
      />
      <path
        d="M17.9246 8.8082L17.3715 9.93789L18.2715 10.8145L17.0293 10.6363L16.4762 11.7613L16.2605 10.5238L15.0137 10.3457L16.1293 9.75977L15.9137 8.51758L16.8137 9.39414L17.9246 8.8082Z"
        fill="#FFDA44"
      />
      <path
        d="M14.2602 5.38672L14.1664 6.63828L15.3336 7.11172L14.1102 7.41172L14.0211 8.66797L13.3602 7.59922L12.1367 7.89922L12.9477 6.93828L12.282 5.87422L13.4492 6.34766L14.2602 5.38672Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_702_5000">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({})
</script>
